import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "coins-list" }

import StoreItemDTO from "@/models/StoreItemDTO";
import CoinsBundle from "@/components/store/CoinsBundle.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CoinsStore',
  props: {
    coins: {}
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.coins, (item) => {
      return (_openBlock(), _createBlock(CoinsBundle, {
        key: item.id,
        item: item
      }, null, 8, ["item"]))
    }), 128))
  ]))
}
}

})